import { ArrowRight } from "lucide-react";
import { useTranslation } from "@/i18n/useTranslation";

export function CTA() {
  const { t } = useTranslation();
  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto max-w-[1440px] px-5 md:px-6">
        <div className="rounded-2xl border border-border bg-white p-10 md:p-14 text-center">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">{t("cta.title")}</h2>
          <p className="mt-4 max-w-xl mx-auto text-muted-foreground leading-relaxed">{t("cta.subtitle")}</p>
          <a
            href="https://admin.cookierobot.info/register"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-7 inline-flex items-center gap-2 rounded-md bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground border border-[hsl(208,71%,30%)] hover:bg-[hsl(208,71%,34%)] transition-colors"
          >
            {t("cta.button")} <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
